<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card
        outlined
        class="rounded-lg h-100"
        @click="goToSession(session.id)"
        :elevation="hover ? 1 : 0"
      >
        <v-card-text>
          <div class="d-flex flex-column">
            <div class="d-flex align-center mb-1">
              <v-avatar
                v-if="session?.workspace?.name"
                size="24"
                color="primary"
                class="mr-2"
              >
                <v-icon small color="white">mdi-account-group-outline</v-icon>
              </v-avatar>
              <v-avatar v-else size="24" color="grey lighten-2" class="mr-2">
                <v-icon small color="grey darken-2">mdi-forum-outline</v-icon>
              </v-avatar>

              <span
                v-if="session?.workspace?.name"
                class="text-caption primary--text"
              >
                {{ getSessionHeader(session) }}
              </span>
            </div>

            <span class="text-subtitle-2 font-weight-medium text-truncate-container">
              {{ getSessionName(session) }}
            </span>
          </div>

          <div class="text-caption text--secondary mt-1">
            {{ getTime(session.updatedAt) }}
          </div>

          <div class="deleteSessionBtn">
            <v-btn
                icon
                @click.stop="removeSession(session.id)"
                :loading="deleteSessionLoading && deleteSessionId === session.id"
            >
              <v-icon style="color: red"> mdi-delete </v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
import * as moment from 'moment/moment';
import {createNamespacedHelpers} from "vuex";

const {
  mapMutations: AIChatMutations,
  mapActions: AIChatActions,
  mapGetters: AIChatGetters,
} = createNamespacedHelpers("AIChat");

export default {
  name: 'ChatSessionCard',
  props: {
    session: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      deleteSessionId: null,
      channelTypeView: {
        'slack': 'Slack',
        'sms': 'Twilio SMS',
        'incoming_event': 'Incoming Event'
      }
    }
  },
  computed: {
    ...AIChatGetters({
      sessions: 'SESSIONS_LIST',
      deleteSessionLoading: 'GET_DELETE_SESSION_LOADING',
    }),
  },
  methods: {
    ...AIChatActions([
        "deleteSession",
    ]),
    ...AIChatMutations({
      setSessions: 'SET_SESSIONS_LIST',
    }),
    getTime(date) {
      return moment(date).fromNow();
    },
    goToSession(id) {
      this.$router.push({ path: `/ai-chat`, query: { session: id } });
    },
    async removeSession(id) {
      this.deleteSessionId = id;
      const filteredSessions = this.sessions.filter((item) => item.id !== id);
      await this.deleteSession({ sessionId: id });
      this.setSessions(filteredSessions);
    },
    getSessionHeader(session) {
      if(session.channelType !== 'http') {
        let header = `${this.channelTypeView[session.channelType]}. ${session.workspace.name}`;
        return header;
      }
      return session?.workspace?.name;
    },
    getSessionName(session) {
      if(session.channelType !== 'http') {
        switch (session.channelType) {
          case 'slack':
            return session.externalUserId;
          case 'incoming_event':
            return session.externalChannelId;
          case 'sms':
            return session.externalUserId;
        }
      }
      return session.name;
    }
  },
};
</script>

<style scoped>
.text-truncate-container {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.deleteSessionBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  elevation: higher;
}
</style>
